import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Header() {
  const [value, setValue] = useState("");
  const [valuevendor, setValuevendor] = useState("");
  const [valuesetUserDeatils, setUserDeatils] = useState({});

  useEffect(() => {
    if (typeof window !== "undefined") {
      setValue(localStorage.getItem("access_token"));
      setValuevendor(localStorage.getItem("access_token_vendor"));

      const userDetails = localStorage.getItem("access_user");

      setUserDeatils(JSON?.parse(userDetails));
    } else {
      setValue("");
      setValuevendor("");
      setUserDeatils({});
    }
  }, []);
  return (
    <div className="treasure">
      {/* <!-- header-start --> */}
      <div
        class="container header-fixed pt-2 pb-3"
        style={{ backgroundColor: "aliceblue" }}
      >
        <div class="row">
          <div class="col-12 d-flex align-items-left ">
            {/* <!-- Logo --> */}
            <div class="logo mt-2"
            //  style={{ width: "150px" }}
             >
              <a href="/">
              <img src="/img/logo.png" alt="logo" class="w-100" />
              </a>
            </div>

            <div class="header-up-icons d-flex ms-auto ">
              {/* <a class="mt-2" href="">
                  <img src="img/bell.png" alt="" class="w-75" />
                </a> */}
              {/* <a class="mt-2 text-decoration-none" href="">
                <h5 class="fw-bold airdrop-color ">Airdrop</h5>
              </a> */}

              <div class="btn-group">
                <button
                  type="button"
                  class="btn dropdown-toggle  border-0 mt-1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img class="w-75" src="/img/togle.jpg" alt="" />
                </button>
                <ul class="dropdown-menu ">
                  <li class="m-2">
                    <Link class="dropdown-item" to="/">
                      <img src="/img/icons8-home-20.png" alt="" />
                      Home
                    </Link>
                  </li>
                  <li class="m-2">
                    <Link class="dropdown-item text-green" to="/myabout">
                     
                    <b> About Us</b> 
                    </Link>
                  </li>
                  <li class="m-2">
                    <Link class="dropdown-item" to="/blognew">
                   
                    <b> Our Blog</b> 
                    </Link>
                  </li>
                  <li class="m-2">
                    <Link class="dropdown-item" to="/ongoing_project">
                      
                     <b>Projects</b> 
                    </Link>
                  </li>
                { !value && <li class="m-2">
                    <Link class="dropdown-item" to="/login">
                      <b>Login</b>
                    </Link>
                  </li>}
                { !value && <li class="m-2">
                    <Link class="dropdown-item" to="/register">
                  <b> Register</b> 
                    </Link>
                  </li>}
                  {/* <li class="m-2">
                    <a class="dropdown-item" href="#">
                      <img src="/img/icons8-telegram-20.png" alt="" /> telegram
                    </a>
                  </li> */}
                  {/* <li class="m-2">
                    <a class="dropdown-item" href="#">
                      <img src="img/icons8-message-20.png" alt="" /> Internal
                      Message
                    </a>
                  </li>
                  <li class="m-2">
                    <a class="dropdown-item" href="#">
                      <img src="img/icons8-security-lock-20.png" alt="" />{" "}
                      Security TAP
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div class="container header-down-position">
        <div class="row header-down-m">
          <div
            class=" border  rounded-pill header-down-border"
            style={{ backgroundColor: "#0A2648" }}
          >
            <div class="d-flex justify-content-around align-items-center text-center">
              <Link
                class="text-decoration-none"
                to={value ? "/stake" : "/login"}
              >
                <div>
                  <h6 class="header-down-h6 text-white mt-2">Plot</h6>
                </div>
              </Link>
              |
              <Link
                class="text-decoration-none"
                to={value ? "/earn" : "/login"}
              >
                <div>
                  <h6 class="header-down-h6 text-white mt-2">Earn</h6>
                </div>
              </Link>
              |
              <Link
                class="text-decoration-none"
                to={value ? "/reserve" : "/login"}
              >
                <div>
                  <h6 class="header-down-h6 text-white mt-2">Reserve</h6>
                </div>
              </Link>
              |
              <Link
                class="text-decoration-none"
                to={value ? "/assets" : "/login"}
              >
                <div>
                  <h6 class="header-down-h6 text-white mt-2">Assets</h6>
                </div>
              </Link>
              |
              <Link class="text-decoration-none" to={value ? "/my" : "/login"}>
                <div>
                  <h6 class="header-down-h6 text-white mt-2">Dashboard</h6>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div class="container">
        <div class="row">
          <button class="btn header-help-position">
            <img src="img/icons8-message-25.png" alt="" />
            <h6 class="">Help</h6>
          </button>
        </div>
      </div> */}

      {/* <!-- header-end --> */}
    </div>
  );
}

export default Header;
